var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconCheck = function SvgIconCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#DCDC1D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0757 16.2984L6.17573 12.3984C5.94142 12.1641 5.94142 11.7842 6.17573 11.5499L7.02424 10.7014C7.25854 10.467 7.63846 10.467 7.87277 10.7014L10.5 13.3286L16.1272 7.70136C16.3615 7.46706 16.7414 7.46706 16.9758 7.70136L17.8243 8.54989C18.0586 8.7842 18.0586 9.1641 17.8243 9.39843L10.9243 16.2985C10.6899 16.5328 10.31 16.5328 10.0757 16.2984Z",
    fill: "#213842"
  })));
};
export default SvgIconCheck;